export const getActivityName = (type: number) => {
  let path = '-'

  switch (type) {
    case 1:
      path = 'activityName.availability'
      break
    case 2:
      path = 'activityName.work'
      break
    case 3:
      path = 'activityName.driving'
      break
    case 0:
      path = 'activityName.rest'
      break
    case 4:
      path = 'activityName.unknown'
      break
  }

  return path
}
